import _ from 'lodash';

export default angular
  .module('doxy.common.directives.clickExact', [])
  .directive('clickExact', function () {
    return {
      restrict: 'A',
      scope: false,
      link: function ($scope, $el, attrs) {
        const ignoreClasses = attrs.clickIgnoreChildren.split(',');

        const callback = (e) => {
          const ignoreChildrenElements = _.compact(
            _.flatten(
              ignoreClasses.map((selector) =>
                Array.from($el[0].querySelectorAll(selector))
              )
            )
          );

          const clickOnBlockedElements = _.some(ignoreChildrenElements, (el) =>
            el.contains(e.target)
          );
          if (!clickOnBlockedElements) {
            $scope.$apply(attrs.clickExact);
          }
        };
        $el.bind('click', callback);
        $scope.$on('$destroy'),
          () => {
            $el.unbind('click', callback);
          };
      },
    };
  }).name;
